/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DecimalRangeFilter
 */
export interface DecimalRangeFilter {
    /**
     * 
     * @type {number}
     * @memberof DecimalRangeFilter
     */
    min?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DecimalRangeFilter
     */
    max?: number | null;
}

/**
 * Check if a given object implements the DecimalRangeFilter interface.
 */
export function instanceOfDecimalRangeFilter(value: object): value is DecimalRangeFilter {
    return true;
}

export function DecimalRangeFilterFromJSON(json: any): DecimalRangeFilter {
    return DecimalRangeFilterFromJSONTyped(json, false);
}

export function DecimalRangeFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): DecimalRangeFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
    };
}

export function DecimalRangeFilterToJSON(json: any): DecimalRangeFilter {
    return DecimalRangeFilterToJSONTyped(json, false);
}

export function DecimalRangeFilterToJSONTyped(value?: DecimalRangeFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'min': value['min'],
        'max': value['max'],
    };
}

